import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/profile/page.tsx");
